import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


const ItSolutionDetails = ({ service }) => {


  // console.log(service)

  return (
    <div className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14 space-y-10">

      {/* SECTION 1 */}
      <div data-aos="fade-up-right" data-aos-duration="1000" className="grid lg:grid-cols-2 gap-10 items-center">
        <div className="space-y-4">
          <h2 data-aos="fade-up" data-aos-duration="1000" className="text-2xl md:text-4xl font-semibold font-SpaceGrotesk text-primaryColor">
            {service?.section1?.heading}
          </h2>
          <p data-aos="fade-up" data-aos-duration="1000" className="text-gray-600 text-justify lg:text-left leading-relaxed">
            {service?.section1?.description}
          </p>
        </div>
        <div data-aos="fade-up-left" data-aos-duration="1000" className="flex justify-center">
          <img src={service?.section1?.image} alt="IT Solution" className="rounded-xl object-cover object-top w-full md:h-[25rem] lg:h-auto" />
        </div>
      </div>

      {/* SECTION 2 */}
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div data-aos="fade-up-right" data-aos-duration="1000" className="flex justify-center">
          <img src={service?.section2?.image} alt="IT Solution" className="rounded-xl object-cover object-top w-full md:h-[25rem] lg:h-auto" />
        </div>

        <div className="space-y-6">
          <h2 data-aos="fade-up" data-aos-duration="1000" className="text-2xl md:text-4xl font-semibold font-SpaceGrotesk text-primaryColor">
            {service?.section2?.heading}
          </h2>

          <p data-aos="fade-up" data-aos-duration="1000" className="text-gray-600 text-justify lg:text-left leading-relaxed">
            {service?.section2?.description}
          </p>

          <div data-aos="fade-up" data-aos-duration="1000" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">

            {service?.section2?.tesmimonials?.map((t, index) => (
              < div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className="group flex flex-col justify-center items-center h-32 w-full text-center gap-3 p-3 rounded-2xl border border-blue-500 bg-white shadow-md hover:shadow-xl transition duration-300" >
                <div className="flex flex-col justify-center items-center gap-2 border border-dashed border-gray-500 rounded-xl p-1 w-full h-full group-hover:bg-blue-50 transition">
                  <img src={t.icon} alt="icon" className="w-12" />
                  <p className="font-semibold text-sm text-[#0A165E]">{t.label}</p>
                </div>
              </div>
            ))}

          </div>


        </div>
      </div>

    </div >
  );
};

export default ItSolutionDetails;
